
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
      getBgmList:`get /apis/baohuo-yuanchuang/backgroundMusic/queryTypeSoundList`,//背景音列表
      getVideoStatus:`get /apis/baohuo-yuanchuang/backgroundMusic/queryVideoStatus`,//视频状态
      deleteBgmById:{//删除背景音
        custom: true,
        url: (data: any) => `/apis/baohuo-yuanchuang/backgroundMusic/delete/${data.id}`,
        method: 'get'
      },
      // extractBgmByUrl:`post /apis/baohuo-yuanchuang/backgroundMusic/extractSound`//改用ajax原生
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"ChooseBgm"
			})
		}